const iframes = document.querySelectorAll('iframe');
if (iframes.length) {
	iframes.forEach((iframe) => {
		iframe.addEventListener('load', () => {
			iframe.classList.add('loaded');
		});
	});
}

const abc7iframes = document.querySelectorAll('iframe[src*="abc7.com"]');
if (abc7iframes) {
	abc7iframes.forEach((iframe) => {
		iframe.setAttribute('scrolling', 'no');
		if (!iframe.previousElementSibling && !iframe.nextElementSibling && iframe.parentElement.tagName === 'FIGURE') {
			iframe.parentElement.classList.add('responsive-video');
		}
	});
}
